/**
 * API клієнт для ref.pos_providers (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/pos-providers. Permissions: retail.pos_provider.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export type PosProviderType = 'checkbox' | 'vchasno' | 'mock';

export interface PosProvider {
  id: string;
  organization_id: string;
  code: string;
  name: string;
  provider_type: PosProviderType;
  is_connected: boolean;
  is_active: boolean;
  config: Record<string, unknown>;
  last_test_at: string | null;
  last_test_status: string | null;
  last_test_message: string | null;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface PosProviderCreate {
  organization_id: string;
  code: string;
  name: string;
  provider_type: PosProviderType;
  is_connected?: boolean;
  is_active?: boolean;
  config?: Record<string, unknown>;
  comment?: string | null;
}

export type PosProviderUpdate = Partial<Omit<PosProviderCreate, 'organization_id'>>;

export interface PosProviderTestConnectionOut {
  success: boolean;
  provider_type: PosProviderType;
  last_test_at: string;
  last_test_status: string;
  last_test_message: string | null;
}

export const retailPosProviders = {
  list: (params?: { organization_id?: string; is_active?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<PosProvider>>('/retail/pos-providers', { params }).then((r) => r.data),
  get: (id: string) => api.get<PosProvider>(`/retail/pos-providers/${id}`).then((r) => r.data),
  create: (payload: PosProviderCreate) =>
    api.post<PosProvider>('/retail/pos-providers', payload).then((r) => r.data),
  update: (id: string, payload: PosProviderUpdate) =>
    api.patch<PosProvider>(`/retail/pos-providers/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/pos-providers/${id}`).then(() => undefined),
  testConnection: (id: string) =>
    api.get<PosProviderTestConnectionOut>(`/retail/pos-providers/${id}/test-connection`).then((r) => r.data),
};
